var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D56060",
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.037 10.725v-1.04c0-1.48-1.33-2.685-2.963-2.685-1.634 0-2.963 1.205-2.963 2.685v1.04A1.34 1.34 0 0 0 8 12.043v3.618C8 16.4 8.6 17 9.339 17h5.47c.739 0 1.34-.6 1.34-1.339v-3.619c0-.66-.482-1.209-1.112-1.317zm-5.556-1.04c0-1.276 1.163-2.315 2.593-2.315s2.593 1.039 2.593 2.315v1.019H9.48V9.685zm6.297 5.976a.97.97 0 0 1-.969.969H9.34a.97.97 0 0 1-.969-.969v-3.619a.97.97 0 0 1 .969-.968h5.47a.97.97 0 0 1 .969.968v3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.074 12.185a.741.741 0 0 0-.74.74v1.112a.741.741 0 0 0 1.48 0v-1.111a.741.741 0 0 0-.74-.74zm.37 1.852a.37.37 0 0 1-.74 0v-1.111a.37.37 0 0 1 .74 0v1.111z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending1);
export default __webpack_public_path__ + "static/media/pending_1.40a610c5e04659eb888aaa96b5589fe1.svg";
export { ForwardRef as ReactComponent };